<template>
    <div class="block-content block-content-full overflow-hidden mb-2 rounded-12">
        <div class="block w-80">
            <div class="block-header pb-4">
                <h3 class="text-center block-title fs-5 fw-semibold text-light-blue">Informations générales</h3>
            </div>
            <div class="row justify-content-center">
                <div class="col-sm-10 col-md-11">
                    <div class="row justify-content-center">
                        <form @submit.prevent="handleSubmit">
                            <div class="row">
                                <div class="col-lg-12 col-md-12">
                                    <div class="form-group">
                                        <label for="name" class="form-label">Nom/Num.<span class="text-purple">*</span></label>
                                        <input
                                            id="name"
                                            v-model="pack.name"
                                            class="form-control"
                                            placeholder="Nom/Num."
                                            required
                                        />
                                    </div>
                                </div>
                            </div>

                            <div class="d-flex justify-content-center mt-4 flex-wrap px-6 gap-40 pt-2">
                                <a
                                    href="/back-office/food/tables"
                                    class="btn btn-outline-dark height_btn_page line_height41 rounded-12 fw-semibold width-btn"
                                >
                                    Annuler
                                </a>
                                <button type="submit" class="btn btn-dark height_btn_page rounded-12 fw-semibold width-btn">
                                    {{ Object.keys(this.data).length === 0 ? 'Ajouter' : 'Mettre à jour' }}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import ApiManager from '../Api/ApiManagerFood.js'

export default {
    props: ['data', 'country_vat_rates'],
    data() {
        return {
            pack: {
                name: '',
                origin: '',
                subtitle: '',
                description: '',
                seo_description: '',
                seo_title: '',
                seo_keywords: '',
                short_description: '',
                image: '',
                price: '',
                price_ht: '',
                vat_rate: 0,
                price_takeaway: '',
                price_ht_takeaway: '',
                vat_rate_takeaway: 0,
                items: [],
                is_active_takeaway: false,
            },
            kitchens: [],
            foods: [],
        }
    },

    computed: {
        listFoods() {
            return this.foods
        },
        listKitchens() {
            return this.kitchens
        },
    },

    methods: {
        formatPriceWithSymbol(price, decimal = 2) {
            if (price == null || price == '') return '--.--'
            return `${price.toFixed(decimal)} ${this.$symbolCurrency}`
        },

        formatPrice(price, decimal = 2) {
            if (price == null || price == '') return null
            return `${price.toFixed(decimal)}`
        },

        isEven(index) {
            return index % 2 === 0
        },

        addItem() {
            this.pack.items.push({
                name: '',
                food: null,
                active: true,
            })
        },

        deleteItem(index) {
            this.pack.items.splice(index, 1)
        },

        updateSelectedFood(item, food) {
            item.food = food
        },

        calculatePrice() {
            const price = parseFloat(this.pack.price) || 0
            const vatRate = parseFloat(this.pack.vat_rate) || 0

            this.pack.price_ht = (price / (1 + vatRate / 100)).toFixed(this.$priceHtDecimal)
        },

        calculatePriceHT() {
            const priceHT = parseFloat(this.pack.price_ht) || 0
            const vatRate = parseFloat(this.pack.vat_rate) || 0

            this.pack.price = (priceHT * (1 + vatRate / 100)).toFixed(this.$priceDecimal)
        },

        calculatePriceTakeaway() {
            const price = parseFloat(this.pack.price_takeaway) || 0
            const vatRate = parseFloat(this.pack.vat_rate_takeaway) || 0

            this.pack.price_ht_takeaway = (price / (1 + vatRate / 100)).toFixed(this.$priceHtDecimal)
        },

        calculatePriceHTTakeaway() {
            const priceHT = parseFloat(this.pack.price_ht_takeaway) || 0
            const vatRate = parseFloat(this.pack.vat_rate_takeaway) || 0

            this.pack.price_takeaway = (priceHT * (1 + vatRate / 100)).toFixed(this.$priceDecimal)
        },

        handleIsActiveTakeawayChange(event) {
            if (!event.target.checked) {
                this.pack.price_takeaway = ''
                this.pack.price_ht_takeaway = ''
                this.pack.vat_rate_takeaway = 0
            }
        },

        handleSubmit() {
            if (Object.keys(this.data).length !== 0) {
                this.updatePack()
            } else {
                this.storePack()
            }
        },

        storePack() {
            axios
                .post('/back-office/food/pack', this.pack)
                .then((response) => {
                    console.log('pack created:', response.data)
                    window.location.href = '/back-office/food/pack/'
                    this.$toast.success(this.$t('food.packs.created_success'))
                })
                .catch((error) => {
                    console.error('Error creating pack:', error)
                    this.showErrors(error)
                })
        },

        updatePack() {
            const packId = this.data.id

            axios
                .put(`/back-office/food/pack/${packId}`, this.pack)
                .then((response) => {
                    console.log('updated:', response.data)
                    this.$toast.success(this.$t('food.packs.updated_success'))
                })
                .catch((error) => {
                    console.error('Error updating pack:', error)
                    this.showErrors(error)
                })
        },

        async fetchFoods() {
            try {
                const params = new URLSearchParams({
                    categories: [this.slug].join(','),
                    select: ['id', 'slug', 'name', 'price', 'price_ht', 'price_takeaway', 'price_ht_takeaway'],
                    groupBy: [],
                })
                const data = await ApiManager.fetchFood(params)
                this.foods = data.data
            } catch (error) {
                this.$toast.error(error.response.data.message)
            }
        },

        showErrors(response) {
            console.log('response', response)
            if (response && response.data && response.data.errors) {
                const errors = response.data.errors

                console.log('errors', errors)

                for (const key in errors) {
                    const errorMessage = errors[key][0]

                    console.log('errorMessage', errorMessage)

                    this.showErrorNotification(errorMessage)
                }
            } else {
                this.showErrorNotification('An error occurred. Please try again.')
            }
        },

        showErrorNotification(message) {
            this.$toast.error(message)
        },

        handleImageUpload(event) {
            const file = event.target.files[0]
            if (file) {
                const reader = new FileReader()
                reader.onload = (e) => {
                    this.pack.image = e.target.result
                }
                reader.readAsDataURL(file)
            }
        },
    },

    mounted() {
        if (Object.keys(this.data).length !== 0) {
            this.pack = { ...this.data }

            this.pack.price = this.formatPrice(this.pack?.price || 0, this.$priceDecimal)
            this.pack.price_takeaway = this.formatPrice(this.pack?.price_takeaway || 0, this.$priceDecimal)

            this.pack.is_active_takeaway = this.pack.price_takeaway > 0 ? true : false

            this.pack.category_id = {
                id: this.data?.category?.id,
                name: this.data?.category?.name,
            }

            this.pack.kitchen_id = {
                id: this.data?.kitchen?.id,
                name: this.data?.kitchen?.name,
            }
        }
        // this.fetchMenus()
        this.fetchFoods()
    },

    components: {
        vSelect,
    },
}
</script>

<style lang="scss">
#selectFoodMenu .vs__dropdown-toggle,
#kitchen .vs__dropdown-toggle {
    color: #94a3b8;
    background-color: #fff;
    border-color: #e2e8f0;
    border-radius: 12px;
    min-height: 56px;
}

.odd-background {
    background-color: #7d2dbd70;
    border-radius: 8px;
}

.even-background {
    background-color: #02183212;
    border-radius: 8px;
}
</style>
